import React, { useState } from "react";
import QuickAddDialog from "./QuickAddDialog";
import EnquiryFormDrawer from "./EnquiryFormDrawer";

/**
 * Quick Add dialog + full Add drawer, shared by Today and Enquiries.
 * onAdded(enquiry, message) runs after a save; a matching mobile is mentioned.
 */
export default function useAddEnquiry(onAdded) {
  const [quickOpen, setQuickOpen] = useState(false);
  const [fullOpen, setFullOpen] = useState(false);

  const handleSaved = (res) => {
    setQuickOpen(false);
    setFullOpen(false);
    const dup = (res.possibleDuplicates || [])[0];
    const msg = dup
      ? `${res.enquiry.enquiryNo} added. Same mobile as ${dup.enquiryNo} (${dup.parentName || dup.childName}).`
      : res.message || `${res.enquiry.enquiryNo} added.`;
    onAdded && onAdded(res.enquiry, msg);
  };

  const nodes = (
    <>
      <QuickAddDialog
        open={quickOpen}
        onClose={() => setQuickOpen(false)}
        onSaved={handleSaved}
        onMoreDetails={() => {
          setQuickOpen(false);
          setFullOpen(true);
        }}
      />
      <EnquiryFormDrawer open={fullOpen} enquiry={null} onClose={() => setFullOpen(false)} onSaved={handleSaved} />
    </>
  );
  return { openQuick: () => setQuickOpen(true), openFull: () => setFullOpen(true), nodes };
}
